import { render, staticRenderFns } from "./PaddingBottomIcon.vue?vue&type=template&id=e1d5faea&"
import script from "./PaddingBottomIcon.vue?vue&type=script&lang=js&"
export * from "./PaddingBottomIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports